<style>
.left-box{
  transition: all 0.3s;
  overflow: hidden;
  background: white;
}
.left-content{
  width: 200px;
  margin: 20px;
}
.left-box .el-menu{
  text-align:left;
  box-shadow: 0 0 10px #BDBDBD;
  border-radius: 5px;
  background: white;
}
.el-menu--inline{
  border-radius: 0px !important;
  box-shadow: 0 0 0 white !important;
  border-top: 1px solid #e6e6e6 !important;
  border-bottom: 1px solid #e6e6e6 !important;
}
</style>
<template>
  <div class="left-box">
    <div class="left-content">
      <el-menu :default-active="$route.path" :unique-opened="isUnique" :router="isRouter" mode="vertical">
        <template v-for="item in menu">
          <el-submenu :index="item.path" :key="item.path" v-if="item.children">
            <template slot="title" style="height:40px">
              <i :class="item.icon"></i>
              <span slot="title" style="height:40px">{{item.name}}</span>
            </template>
            <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path">
              <i :class="child.icon"></i>
              <span slot="title">{{child.navName}}</span>
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </div>
  </div>
</template>
<script>
export default {
  name: "leftslider",
  data() {
    return {
      isUnique: true,
      isRouter: true,
      level: '',
      menu: this.$router.options.routes,
    };
  },
  created() {
    // console.log(this.$router.options.routes);
    this.level = JSON.parse(localStorage.getItem("USER")).level;
    // console.log(JSON.parse(localStorage.getItem("USER")))
    if(this.level != 0){
      this.$router.options.routes.splice(4,1);
      this.$router.options.routes[2].children.splice(1,1);
    }
    if(this.level == 2){
      this.$router.options.routes.splice(3,1);
    }
  },
  methods:{
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/left.vue